import React, { useMemo } from 'react'
import type { Relationship } from '../../api/relationships'

export default function BlockedAccountRow({ relation, onUnblock, disabled }: { relation: Relationship; onUnblock: () => void; disabled?: boolean }) {
  const profile = relation.target_profile as any
  const person = relation.target_person as any
  const displayName: string = profile?.display_name || person?.display_name || 'Blocked account'
  const handle: string | undefined = profile?.handle ? `@${profile.handle}` : undefined
  const avatarUrl: string | undefined = profile?.avatar_url || person?.avatar_url || undefined
  const initials = useMemo(() => {
    const name = (displayName || '').trim()
    const letters = name
      .split(' ')
      .map((chunk) => chunk.trim()[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase()
    return letters || 'PL'
  }, [displayName])

  return (
    <div className="flex items-center justify-between gap-3 py-3 border-t border-white/10 first:border-t-0">
      <div className="flex items-center gap-3 min-w-0">
        {avatarUrl ? (
          <img src={avatarUrl} alt={displayName} className="h-11 w-11 rounded-full object-cover" />
        ) : (
          <div className="h-11 w-11 rounded-full bg-white/10 flex items-center justify-center">
            <span className="text-white font-bold">{initials}</span>
          </div>
        )}
        <div className="min-w-0">
          <div className="text-white font-semibold truncate">{displayName}</div>
          {handle ? <div className="text-xs text-white/65 truncate">{handle}</div> : null}
        </div>
      </div>
      <button onClick={onUnblock} disabled={disabled} className="px-3 py-1.5 rounded-full border border-white/30 text-white/90 font-semibold hover:bg-white/5 disabled:opacity-50">Unblock</button>
    </div>
  )
}

